// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/view/stock/Stock.css
// module id = 72
// module chunks = 0